/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { OriginalTokenVaultV2, OriginalTokenVaultV2Interface } from "../OriginalTokenVaultV2";

const _abi = [
  {
    inputs: [
      {
        internalType: "contract ISigsVerifier",
        name: "_sigsVerifier",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "period",
        type: "uint256",
      },
    ],
    name: "DelayPeriodUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "threshold",
        type: "uint256",
      },
    ],
    name: "DelayThresholdUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bytes32",
        name: "id",
        type: "bytes32",
      },
    ],
    name: "DelayedTransferAdded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bytes32",
        name: "id",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "address",
        name: "receiver",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "DelayedTransferExecuted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bytes32",
        name: "depositId",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "address",
        name: "depositor",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint64",
        name: "mintChainId",
        type: "uint64",
      },
      {
        indexed: false,
        internalType: "address",
        name: "mintAccount",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint64",
        name: "nonce",
        type: "uint64",
      },
    ],
    name: "Deposited",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "length",
        type: "uint256",
      },
    ],
    name: "EpochLengthUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "cap",
        type: "uint256",
      },
    ],
    name: "EpochVolumeUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "GovernorAdded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "GovernorRemoved",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "MaxDepositUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "MinDepositUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Paused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "PauserAdded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "PauserRemoved",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Unpaused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bytes32",
        name: "withdrawId",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "address",
        name: "receiver",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint64",
        name: "refChainId",
        type: "uint64",
      },
      {
        indexed: false,
        internalType: "bytes32",
        name: "refId",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "address",
        name: "burnAccount",
        type: "address",
      },
    ],
    name: "Withdrawn",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_account",
        type: "address",
      },
    ],
    name: "addGovernor",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "addPauser",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "delayPeriod",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "delayThresholds",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    name: "delayedTransfers",
    outputs: [
      {
        internalType: "address",
        name: "receiver",
        type: "address",
      },
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "timestamp",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
      {
        internalType: "uint64",
        name: "_mintChainId",
        type: "uint64",
      },
      {
        internalType: "address",
        name: "_mintAccount",
        type: "address",
      },
      {
        internalType: "uint64",
        name: "_nonce",
        type: "uint64",
      },
    ],
    name: "deposit",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
      {
        internalType: "uint64",
        name: "_mintChainId",
        type: "uint64",
      },
      {
        internalType: "address",
        name: "_mintAccount",
        type: "address",
      },
      {
        internalType: "uint64",
        name: "_nonce",
        type: "uint64",
      },
    ],
    name: "depositNative",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "epochLength",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "epochVolumeCaps",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "epochVolumes",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "id",
        type: "bytes32",
      },
    ],
    name: "executeDelayedTransfer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "governors",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_account",
        type: "address",
      },
    ],
    name: "isGovernor",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "isPauser",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "lastOpTimestamps",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "maxDeposit",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "minDeposit",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "nativeWrap",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "pause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "pausers",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    name: "records",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_account",
        type: "address",
      },
    ],
    name: "removeGovernor",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "removePauser",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceGovernor",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renouncePauser",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_period",
        type: "uint256",
      },
    ],
    name: "setDelayPeriod",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "_tokens",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "_thresholds",
        type: "uint256[]",
      },
    ],
    name: "setDelayThresholds",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_length",
        type: "uint256",
      },
    ],
    name: "setEpochLength",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "_tokens",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "_caps",
        type: "uint256[]",
      },
    ],
    name: "setEpochVolumeCaps",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "_tokens",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "_amounts",
        type: "uint256[]",
      },
    ],
    name: "setMaxDeposit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "_tokens",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "_amounts",
        type: "uint256[]",
      },
    ],
    name: "setMinDeposit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_weth",
        type: "address",
      },
    ],
    name: "setWrap",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "sigsVerifier",
    outputs: [
      {
        internalType: "contract ISigsVerifier",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "unpause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "_request",
        type: "bytes",
      },
      {
        internalType: "bytes[]",
        name: "_sigs",
        type: "bytes[]",
      },
      {
        internalType: "address[]",
        name: "_signers",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "_powers",
        type: "uint256[]",
      },
    ],
    name: "withdraw",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
];

const _bytecode =
  "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";

type OriginalTokenVaultV2ConstructorParams = [signer?: Signer] | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (xs: OriginalTokenVaultV2ConstructorParams): xs is ConstructorParameters<typeof ContractFactory> =>
  xs.length > 1;

export class OriginalTokenVaultV2__factory extends ContractFactory {
  constructor(...args: OriginalTokenVaultV2ConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "OriginalTokenVaultV2";
  }

  deploy(
    _sigsVerifier: string,
    overrides?: Overrides & { from?: string | Promise<string> },
  ): Promise<OriginalTokenVaultV2> {
    return super.deploy(_sigsVerifier, overrides || {}) as Promise<OriginalTokenVaultV2>;
  }
  getDeployTransaction(
    _sigsVerifier: string,
    overrides?: Overrides & { from?: string | Promise<string> },
  ): TransactionRequest {
    return super.getDeployTransaction(_sigsVerifier, overrides || {});
  }
  attach(address: string): OriginalTokenVaultV2 {
    return super.attach(address) as OriginalTokenVaultV2;
  }
  connect(signer: Signer): OriginalTokenVaultV2__factory {
    return super.connect(signer) as OriginalTokenVaultV2__factory;
  }
  static readonly contractName: "OriginalTokenVaultV2";
  public readonly contractName: "OriginalTokenVaultV2";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): OriginalTokenVaultV2Interface {
    return new utils.Interface(_abi) as OriginalTokenVaultV2Interface;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): OriginalTokenVaultV2 {
    return new Contract(address, _abi, signerOrProvider) as OriginalTokenVaultV2;
  }
}
